<h5 class="mb-3">
  <strong>Basic</strong>
</h5>
<div class="mb-5">
  <nz-mention [nzSuggestions]="suggestions" (nzOnSelect)="onSelect($event)">
    <input placeholder="input here" nzMentionTrigger nz-input [(ngModel)]="inputValue"
      (ngModelChange)="onChange($event)" />
  </nz-mention>
</div>